/*
 *
 * ShelvesRibbon reducer
 *
 */

import ActionTypes from 'containers/Ribbon/ShelvesRibbon/constants';
import { ContainerState } from 'containers/Ribbon/ShelvesRibbon/types';
import { ShelfSelection } from 'lib/modelBuilder/entities/ShelfSelection';

export const initialState: ContainerState = {
  selection: new ShelfSelection(),
  menuOpen: false,
};

function shelvesRibbonReducer(
  state: ContainerState = initialState,
  action: any,
): ContainerState {
  switch (action.type) {
    case ActionTypes.SHELVES_SELECTION_MENU:
      return {
        ...state,
        menuOpen: action.payload.menuOpen,
      };
    case ActionTypes.UPDATE_PROFILE_SELECTION:
      return {
        ...state,
        selection: (action.payload
          .shelfSelectionProfile as ShelfSelection).clone(),
      };
    case ActionTypes.SELECT_ALL_PIECES:
      return {
        ...state,
        selection: state.selection.clone().all(),
      };
    case ActionTypes.SELECT_ALL_DOORS:
      return {
        ...state,
        selection: state.selection.clone().allDoors(),
      };
    case ActionTypes.SELECT_ALL_SIDES:
      return {
        ...state,
        selection: state.selection.clone().allSides(),
      };
    case ActionTypes.DOORS_SELECTION:
      const currentSelectionDoors = state.selection.clone();
      currentSelectionDoors.doors = action.payload.positions;
      return {
        ...state,
        selection: currentSelectionDoors,
      };
    case ActionTypes.TOGGLE_DOOR_SELECTION:
      const currentSelectionDoor = state.selection.clone();
      currentSelectionDoor.toggleDoor(
        action.payload.position,
        action.payload.multi,
      );
      return {
        ...state,
        selection: currentSelectionDoor,
      };
    case ActionTypes.TOGGLE_PANE_SELECTION:
      const currentSelectionPane = state.selection.clone();
      currentSelectionPane.togglePane(
        action.payload.position,
        action.payload.multi,
      );
      return {
        ...state,
        selection: currentSelectionPane,
      };
    case ActionTypes.PANES_SELECTION:
      const currentSelectionPanes = state.selection.clone();
      currentSelectionPanes.panes = action.payload.positions;
      return { ...state, selection: currentSelectionPanes };
    default:
      return state;
  }
}

export default shelvesRibbonReducer;
